/*
 * every U. — About page scroll reveals.
 * Adds `.is-in` to elements when they scroll into view so CSS can:
 *   - fade/slide content (.eu-abt-anim)
 *   - draw the yellow title ring clockwise from the top (.eu-abt-ring)
 *   - grow the yellow separator lines from the left (.eu-abt-rule--anim)
 * Idempotent: safe to include from more than one section.
 */
(function () {
  if (window.__euAboutInit) return;
  window.__euAboutInit = true;

  const SELECTOR = '.eu-abt-anim, .eu-abt-ring, .eu-abt-rule--anim, .kura-anim';

  function reveal(el) {
    el.classList.add('is-in');
  }

  function init() {
    const targets = document.querySelectorAll(SELECTOR);
    if (!targets.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );

    targets.forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when sections are re-rendered in the theme editor.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      window.__euAboutInit = false;
      init();
      window.__euAboutInit = true;
    });
  }
})();
